import BaseService from './BaseService';
import { API_ENDPOINTS } from '../constants';

class AdminService {
  async getDashboard() {
    return BaseService.get(API_ENDPOINTS.ADMIN.DASHBOARD);
  }

  async getUsers(params = {}) {
    return BaseService.get(API_ENDPOINTS.ADMIN.USERS, params);
  }

  async getAdmins(params = {}) {
    return BaseService.get(API_ENDPOINTS.ADMIN.ADMINS, params);
  }

  async updateAdmin(id, data) {
    return BaseService.put(API_ENDPOINTS.ADMIN.UPDATE_ADMIN(id), data);
  }

  async deleteAdmin(id) {
    return BaseService.delete(API_ENDPOINTS.ADMIN.DELETE_ADMIN(id));
  }

  async deleteUser(id) {
    return BaseService.delete(API_ENDPOINTS.ADMIN.DELETE_USER(id));
  }

  async getUserById(id) {
    return BaseService.get(API_ENDPOINTS.ADMIN.USER_BY_ID(id));
  }

  async updateUserStatus(id, data) {
    return BaseService.put(API_ENDPOINTS.ADMIN.UPDATE_USER_STATUS(id), data);
  }

  async banUser(id, data) {
    return BaseService.put(API_ENDPOINTS.ADMIN.BAN_USER(id), data);
  }

  async updateUserRole(id, data) {
    return BaseService.put(API_ENDPOINTS.ADMIN.UPDATE_USER_ROLE(id), data);
  }

  async updateUserPassword(id, data) {
    return BaseService.put(API_ENDPOINTS.ADMIN.UPDATE_USER_PASSWORD(id), data);
  }

  async getSubscriptions(params = {}) {
    return BaseService.get(API_ENDPOINTS.ADMIN.SUBSCRIPTIONS, params);
  }

  async getSubscriptionById(id) {
    return BaseService.get(API_ENDPOINTS.ADMIN.SUBSCRIPTION_BY_ID(id));
  }

  async createSubscription(data) {
    return BaseService.post(API_ENDPOINTS.ADMIN.CREATE_SUBSCRIPTION, data);
  }

  async updateSubscription(id, data) {
    return BaseService.put(API_ENDPOINTS.ADMIN.UPDATE_SUBSCRIPTION(id), data);
  }

  async deleteSubscription(id) {
    return BaseService.delete(API_ENDPOINTS.ADMIN.DELETE_SUBSCRIPTION(id));
  }

  async toggleSubscription(id) {
    return BaseService.put(API_ENDPOINTS.ADMIN.TOGGLE_SUBSCRIPTION(id));
  }

  async getWithdrawals(params = {}) {
    return BaseService.get(API_ENDPOINTS.ADMIN.WITHDRAWALS, params);
  }

  async getWithdrawalById(id) {
    return BaseService.get(API_ENDPOINTS.ADMIN.WITHDRAWAL_BY_ID(id));
  }

  async createWithdrawal(data) {
    return BaseService.post(API_ENDPOINTS.ADMIN.CREATE_WITHDRAWAL, data);
  }

  async updateWithdrawalStatus(id, data) {
    return BaseService.put(API_ENDPOINTS.ADMIN.UPDATE_WITHDRAWAL_STATUS(id), data);
  }

  async updateWithdrawal(id, data) {
    return BaseService.put(API_ENDPOINTS.ADMIN.WITHDRAWAL_BY_ID(id), data);
  }

  async deleteWithdrawal(id) {
    return BaseService.delete(API_ENDPOINTS.ADMIN.DELETE_WITHDRAWAL(id));
  }

  async getPurchases(params = {}) {
    return BaseService.get(API_ENDPOINTS.ADMIN.PURCHASES, params);
  }

  async getPurchaseById(id) {
    return BaseService.get(API_ENDPOINTS.ADMIN.PURCHASE_BY_ID(id));
  }

  async createPurchase(data) {
    return BaseService.post(API_ENDPOINTS.ADMIN.CREATE_PURCHASE, data);
  }

  async updatePurchaseStatus(id, data) {
    return BaseService.put(API_ENDPOINTS.ADMIN.UPDATE_PURCHASE_STATUS(id), data);
  }

  async deletePurchase(id) {
    return BaseService.delete(API_ENDPOINTS.ADMIN.DELETE_PURCHASE(id));
  }

  async getDeposits(params = {}) {
    return BaseService.get(API_ENDPOINTS.ADMIN.DEPOSITS, params);
  }

  async getDepositById(id) {
    return BaseService.get(API_ENDPOINTS.ADMIN.DEPOSIT_BY_ID(id));
  }

  async createDeposit(data) {
    return BaseService.post(API_ENDPOINTS.ADMIN.CREATE_DEPOSIT, data);
  }

  async updateDeposit(id, data) {
    return BaseService.put(API_ENDPOINTS.ADMIN.DEPOSIT_BY_ID(id), data);
  }

  async updateDepositStatus(id, data) {
    return BaseService.put(API_ENDPOINTS.ADMIN.UPDATE_DEPOSIT_STATUS(id), data);
  }

  async deleteDeposit(id) {
    return BaseService.delete(API_ENDPOINTS.ADMIN.DELETE_DEPOSIT(id));
  }

  async getMaterialIngredients(id) {
    return BaseService.get(API_ENDPOINTS.ADMIN.MATERIAL_INGREDIENTS(id));
  }

  async updateMaterialIngredients(id, data) {
    return BaseService.put(API_ENDPOINTS.ADMIN.UPDATE_MATERIAL_INGREDIENTS(id), data);
  }

  async previewIngredients(id, data) {
    return BaseService.post(API_ENDPOINTS.ADMIN.PREVIEW_INGREDIENTS(id), data);
  }

  async getUserAnalytics(params = {}) {
    return BaseService.get(API_ENDPOINTS.ADMIN.ANALYTICS_USERS, params);
  }

  async getCalculationAnalytics(params = {}) {
    return BaseService.get(API_ENDPOINTS.ADMIN.ANALYTICS_CALCULATIONS, params);
  }

  async getRevenueAnalytics(params = {}) {
    return BaseService.get(API_ENDPOINTS.ADMIN.ANALYTICS_REVENUE, params);
  }

  async getSystemStats() {
    return BaseService.get(API_ENDPOINTS.ADMIN.SYSTEM_STATS);
  }

  async cleanupSystem() {
    return BaseService.post(API_ENDPOINTS.ADMIN.SYSTEM_CLEANUP);
  }

  // Manual Users CRUD
  async getManualUsers(params = {}) {
    return BaseService.get(API_ENDPOINTS.ADMIN.MANUAL_USERS, params);
  }

  async getManualUserById(id) {
    return BaseService.get(API_ENDPOINTS.ADMIN.MANUAL_USER_BY_ID(id));
  }

  async createManualUser(data) {
    return BaseService.post(API_ENDPOINTS.ADMIN.CREATE_MANUAL_USER, data);
  }

  async updateManualUser(id, data) {
    return BaseService.put(API_ENDPOINTS.ADMIN.UPDATE_MANUAL_USER(id), data);
  }

  async deleteManualUser(id) {
    return BaseService.delete(API_ENDPOINTS.ADMIN.DELETE_MANUAL_USER(id));
  }

  // Purchased Ideas
  async getPurchasedIdeas(params = {}) {
    return BaseService.get(API_ENDPOINTS.ADMIN.PURCHASED_IDEAS, params);
  }
}

export default new AdminService();
